var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7678 10.2322C14.7441 11.2085 14.7441 12.7915 13.7678 13.7678C12.7915 14.7441 11.2086 14.7441 10.2323 13.7678C9.25596 12.7915 9.25596 11.2085 10.2323 10.2322C11.2086 9.25592 12.7915 9.25592 13.7678 10.2322",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.849 4.1202L15.432 4.3142C15.966 4.4922 16.327 4.9922 16.327 5.5552V6.3922C16.327 7.1042 16.895 7.6852 17.607 7.7002L18.445 7.7182C18.93 7.7282 19.37 8.0072 19.587 8.4412L19.862 8.9912C20.114 9.4952 20.015 10.1032 19.617 10.5012L19.025 11.0932C18.522 11.5962 18.513 12.4092 19.005 12.9232L19.585 13.5292C19.921 13.8802 20.035 14.3872 19.881 14.8482L19.687 15.4312C19.509 15.9652 19.009 16.3262 18.446 16.3262H17.609C16.897 16.3262 16.316 16.8942 16.301 17.6062L16.283 18.4442C16.273 18.9292 15.994 19.3692 15.56 19.5862L15.01 19.8612C14.506 20.1132 13.898 20.0142 13.5 19.6162L12.908 19.0242C12.405 18.5212 11.592 18.5122 11.078 19.0042L10.472 19.5842C10.121 19.9202 9.614 20.0342 9.153 19.8802L8.57 19.6862C8.036 19.5082 7.675 19.0082 7.675 18.4452V17.6082C7.675 16.8962 7.107 16.3152 6.395 16.3002L5.557 16.2822C5.072 16.2722 4.632 15.9932 4.415 15.5592L4.14 15.0092C3.888 14.5052 3.987 13.8972 4.385 13.4992L4.977 12.9072C5.48 12.4042 5.489 11.5912 4.997 11.0772L4.417 10.4712C4.08 10.1192 3.966 9.6112 4.12 9.1512L4.314 8.5682C4.492 8.0342 4.992 7.6732 5.555 7.6732H6.392C7.104 7.6732 7.685 7.1052 7.7 6.3932L7.718 5.5552C7.73 5.0702 8.008 4.6302 8.442 4.4132L8.992 4.1382C9.496 3.8862 10.104 3.9852 10.502 4.3832L11.094 4.9752C11.597 5.4782 12.41 5.4872 12.924 4.9952L13.53 4.4152C13.881 4.0802 14.389 3.9662 14.849 4.1202V4.1202Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f9b54818d4769669c2de99f63773507b.svg";
export { ForwardRef as ReactComponent };